export default "__VITE_ASSET__BGpxNMff__"